import React, { useEffect, useRef } from 'react';
import { createNoise3D } from 'simplex-noise';

const SPACING = 28;
const AMPLITUDE = 3.2;
const SPEED = 0.00045;
const MOUSE_RADIUS = 120;
const MOUSE_FORCE = 18;

export default function WaterBackground() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const noise3D = createNoise3D();
    let mouse = { x: -9999, y: -9999 };
    let t = 0;
    let raf;

    const resize = () => {
      canvas.width  = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener('resize', resize);

    const onMouse = (e) => { mouse.x = e.clientX; mouse.y = e.clientY; };
    window.addEventListener('mousemove', onMouse);

    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      const cols = Math.ceil(canvas.width  / SPACING) + 1;
      const rows = Math.ceil(canvas.height / SPACING) + 1;

      for (let r = 0; r < rows; r++) {
        for (let c = 0; c < cols; c++) {
          const bx = c * SPACING;
          const by = r * SPACING;
          const n  = noise3D(c * 0.12, r * 0.12, t);
          const dx = bx - mouse.x;
          const dy = by - mouse.y;
          const dist = Math.sqrt(dx * dx + dy * dy);
          const push = dist < MOUSE_RADIUS
            ? (1 - dist / MOUSE_RADIUS) * MOUSE_FORCE : 0;
          const x = bx + n * AMPLITUDE + (dist < MOUSE_RADIUS ? (dx / dist) * push : 0);
          const y = by + n * AMPLITUDE + (dist < MOUSE_RADIUS ? (dy / dist) * push : 0);
          const alpha = 0.12 + Math.abs(n) * 0.22;
          ctx.beginPath();
          ctx.arc(x, y, 0.9, 0, Math.PI * 2);
          ctx.fillStyle = `rgba(255,255,255,${alpha.toFixed(3)})`;
          ctx.fill();
        }
      }
      t += SPEED;
      raf = requestAnimationFrame(draw);
    };
    draw();

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('resize', resize);
      window.removeEventListener('mousemove', onMouse);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 0,
        pointerEvents: 'none',
        opacity: 0.7,
      }}
      aria-hidden="true"
    />
  );
}
